import React from "react";
import { Button, Divider } from "@/components/atoms";
import { Badge } from "@/components/atoms/Badge";
import { Tooltip } from "@/components/molecules/Tooltip";
import { InfoIcon } from "@/components/icons/InfoIcon";
import classNames from "classnames";

interface IOfferCardProps {
    offerId: number;
    title: string;
    description: string;
    image: string;
    impressions?: number;
    topOffer?: boolean;
    claims?: {
        total: number;
        email: number;
        sms: number;
    };
}

export const OfferCard: React.FC<IOfferCardProps> = ({ title, description, image, impressions, topOffer, claims }) => {
    return (
        <article
            className={classNames(
                "border border-gray-200",
                "rounded-xl",
                "bg-white",
                "shadow-sm",
                "overflow-hidden",
                "flex flex-col",
                "w-full max-w-[287px] mx-auto",
                "h-full",
            )}
        >
            <div className={classNames("relative", "pb-0")}>
                <div className={classNames("relative", "overflow-hidden")}>
                    <img className={classNames("w-full", "min-h-28 h-full", "object-cover", "bg-center")} src={image} alt={title} />
                    {topOffer && (
                        <div className={classNames("absolute", "top-1", "left-1")}>
                            <Badge variant="success" className=" text-menu-background!  text-[11px]!">
                                Top Offer
                            </Badge>
                        </div>
                    )}
                    <div className={classNames("absolute", "top-1", "right-1", "size-5", "bg-gray-200/80 flex justify-center items-center rounded-full")}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 3l6 6M9 3L3 9" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>

            <div className={classNames("px-3", "pt-3", "flex-1", "flex", "flex-col", "justify-between")}>
                <div className={classNames("")}>
                    <h3
                        className={classNames("text-base", description ? "font-semibold" : "font-normal", "leading-snug", "text-center", description ? "text-[#007CC0]" : "text-menu-background")}
                        dangerouslySetInnerHTML={{ __html: title }}
                    ></h3>
                    {description && (
                        <p className={classNames('mt-2', 'text-sm', 'leading-relaxed', 'font-normal', 'text-center', 'line-clamp-4', 'text-[#007CC0]', 'overflow-hidden')}>
                            {description}
                        </p>
                    )}
                </div>
                <Button className={classNames("mt-5!", "w-full self-center", "rounded-md", description ? "bg-[#007CC0]" : "bg-[#007CC0]", "text-white", "font-bold", "pointer-events-none", "cursor-default")}>
                    Claim Offer
                </Button>
            </div>

            <div className={classNames("text-xs", "text-black", "space-y-2", "px-2 pb-2", "mt-4")}>
                <div className={classNames("flex", "justify-around", "items-center", "py-2", "px-3")}>
                    <div className={classNames("flex", "flex-col", "items-center", "gap-0.5")}>
                        <span className={classNames("text-xs", "text-gray-500")}>
                            Impressions: <br />
                            <span className={classNames("font-bold", "text-sm", "text-menu-background")}>{(impressions ?? 0).toLocaleString()}</span>
                        </span>
                    </div>
                    <div className={classNames("flex", "flex-col", "items-center", "gap-0.5")}>
                        <span className={classNames("text-xs", "text-gray-500")}>
                            Claimed: <br />
                            <span className={classNames("font-bold", "text-sm", "text-menu-background")}>{(claims?.total ?? 0).toLocaleString()}</span>
                        </span>
                    </div>
                </div>

                {/* <div className={classNames('flex', 'justify-center')}> */}
                {/* TODO: Add tooltip back when needed */}
                {/* <Tooltip
                        bgColor="#fff"
                        tooltipClassName="text-black! shadow-md border border-gray-100"
                        arrowColorClassName="border border-gray-100"
                        position="bottom"
                        className="text-slate-800"
                        content={
                            <div className={classNames('flex', 'flex-col', 'gap-1', 'font-normal')}>
                                <p>Claimed by</p>
                                <p>Email: {claims?.email ?? 0}</p>
                                <p>SMS: {claims?.sms ?? 0}</p>
                            </div>
                        }
                    >
                        <div className={classNames('flex', 'gap-1', 'text-sm')}>
                            <span className={classNames('flex', 'items-center', 'gap-1', 'font-bold', 'text-menu-background')}>
                                Claimed:
                            </span>
                            <span className={classNames('font-bold')}>{(claims?.total ?? 0).toLocaleString()}</span>
                            <span className={classNames('inline-flex')}> <InfoIcon /> </span>
                        </div>
                    </Tooltip> */}
                {/* </div> */}
            </div>
        </article>
    );
};
